module.exports = __webpack_public_path__ + "static/media/fsyuce022.4c22f6a4.jpg";